import { EnumSummary } from '../models/enumSummary';


export class EnumService {

    public getErrorEnums(type: string): EnumSummary[] {

        const sgble: EnumSummary[] = [
            new EnumSummary('SGBLEError', 'bluetoothUnsupportedError', 'Bluetooth is not supported on this device.'),
            new EnumSummary('SGBLEError', 'LOCATIONUNAUTHORIZEDERROR [ANDROID SPECIFIC]', 'Location permission not authorized.'),
            new EnumSummary('SGBLEError', 'bluetoothUnauthorizedError', 'Bluetooth permission is unauthorized.'),
            new EnumSummary('SGBLEError', 'bluetoothPoweredOffError', 'Bluetooth is powered off.'),
            new EnumSummary('SGBLEError', 'dataCongruencyError', 'CRC validation errors'),
            new EnumSummary('SGBLEError', 'securityError', 'Encryption/decryption related errors'),
            new EnumSummary('SGBLEError', 'communicationError', 'write/read failure to characteristics'),
            new EnumSummary('SGBLEError', 'invalidDeviceStateError', 'service, characteristic, descriptor discovery, RSSI Read'),
            new EnumSummary('SGBLEError', 'connectionError', 'GATT characteristics not found, connection timeout, bad state changes'),
            new EnumSummary('SGBLEError', 'disconnectionError', 'Improperly disconnected gatt'),
            new EnumSummary('SGBLEError', 'noDeviceFoundError', 'No devices found in scan result'),
        ];

        const sgprofile: EnumSummary[] = [
            new EnumSummary('SGPlayerProfileError', 'unknown', 'Could not get player profile'),
        ];

        const sgtransfer: EnumSummary[] = [
            new EnumSummary('SGFundsTransferError', 'unregisteredAssetError', 'Funds transfer failed since the asset is not registered'),
            new EnumSummary('SGFundsTransferError', 'licensingError', 'Funds transfer failed since the wallet module is not licensed.'),
            new EnumSummary('SGFundsTransferError', 'invalidAssetError', 'Funds transfer failed since the asset is invalid.'),
            new EnumSummary('SGFundsTransferError', 'insufficientFundsError', 'Funds transfer failed due to insufficient funds.'),
            new EnumSummary('SGFundsTransferError', 'timeoutError', 'Funds transfer failed due to a server timeout.'),
            new EnumSummary('SGFundsTransferError', 'fundsTransferError', 'Funds transfer failed. Call attendant.'),
            new EnumSummary('SGFundsTransferError', 'transferInProgressError', 'Funds transfer failed since another transfer is in progress.'),
            new EnumSummary('SGFundsTransferError', 'pinValidationError', 'Unable to validate pin'),
            new EnumSummary('SGFundsTransferError', 'unknown', 'Funds transfer failed due to unknown reasons.'),
        ];

        const sgplayer: EnumSummary[] = [
            new EnumSummary('SGPlayerSessionError', 'invalidCardError', 'Session creation failed because of invalid card number'),
            new EnumSummary('SGPlayerSessionError', 'duplicateSessionError', 'Session creation failed because a session already exists'),
            new EnumSummary('SGPlayerSessionError', 'sessionCreationError', 'The slot failed to create a session'),
            new EnumSummary('SGPlayerSessionError', 'sessionEndingError', 'Failed to end the session'),
            new EnumSummary('SGPlayerSessionError', 'unknown', 'Error due to unknown cause'),
        ];

        const sgbalance: EnumSummary[] = [
            new EnumSummary('SGBalanceError', 'balanceUnavailable', 'Balance is unavailable for this account type'),
            new EnumSummary('SGBalanceError', 'timeout', 'Balance request timed out'),
            new EnumSummary('SGBalanceError', 'unknown', 'unknown error retrieving balance'),
        ];

        const sgprox: EnumSummary[] = [
            new EnumSummary('SGDeviceProximityError', 'proximityDetectionError', 'Error reading the rssi resulting in proximity calculation error.'),
            new EnumSummary('SGDeviceProximityError', 'unknown', ''),
        ];

        const sgchiptrans: EnumSummary[] = [
          new EnumSummary('SGChipTransactionError', 'anotherTransactionInProgress', 'Another transaction is currently in progress'),
          new EnumSummary('SGChipTransactionError', 'transactionFailureError', 'Transaction Failure'),
          new EnumSummary('SGChipTransactionError', 'error', 'Generic error')
        ];

        const sgqr: EnumSummary[] = [
          new EnumSummary('SGQRError', 'cameraAccessPermissionDenied', 'Error reading the rssi resulting in proximity calculation error.'),
          new EnumSummary('SGQRError', 'qrCodeScanFailed', 'Unable to detect QR Code during the scan'),
          new EnumSummary('SGQRError', 'invalidData', 'Data in QR Code is invalid'),
          new EnumSummary('SGQRError', 'communicationError', 'Error communicating to the validation service'),
          new EnumSummary('SGQRError', 'noDataRecieved', 'No meta data received from scanned image'),
          new EnumSummary('SGQRError', 'invalidURL', 'Invalid url supplied in SGConfiguration'),
          new EnumSummary('SGQRError', 'assetNotFound', 'Asset not found'),
          new EnumSummary('SGQRError', 'assetOffline', 'Asset is offline'),
          new EnumSummary('SGQRError', 'dbCommunicationError', 'DB Communication ERror'),
          new EnumSummary('SGQRError', 'qrCodeNotFound', 'QR code not found in DB'),
          new EnumSummary('SGQRError', 'invalidQRCode', 'QR Code is invalid'),
          new EnumSummary('SGQRError', 'sessionAlreadyExists', 'A player session already exists'),
          new EnumSummary('SGQRError', 'internalServerError', 'Validation service down'),
          new EnumSummary('SGQRError', 'unAuthorizedError', 'Unauthorized'),
          new EnumSummary('SGQRError', 'unknown', ''),
      ];

        switch (type) {
            case 'SGBLEError':
                return sgble;
            case 'SGDeviceProximityError':
                return sgprox;
            case 'SGBalanceError':
                return sgbalance;
            case 'SGFundsTransferError':
                return sgtransfer;
            case 'SGPlayerProfileError':
                return sgprofile;
            case 'SGPlayerSessionError':
                return sgplayer;
            case 'SGQRError':
                return sgqr;
            case 'SGChipTransactionError':
                return sgchiptrans;
            default:
                return sgble;
        }

    }

    public getBLEStateEnums(): EnumSummary[]{
        const enums: EnumSummary[] = [
            new EnumSummary('SGBLEConnectionState', 'idle', 'No connection established'),
            new EnumSummary('SGBLEConnectionState', 'scanning', 'Scanning for qualifying gaming machines to connect to'),
            new EnumSummary('SGBLEConnectionState', 'connecting', 'After scanning succesfully completes, it is attempting to connect to device'),
            new EnumSummary('SGBLEConnectionState', 'connected', 'Currently connected and exchanging messages'),
            new EnumSummary('SGBLEConnectionState', 'disconnecting', 'In the process of disconnecting bluetooth'),
            new EnumSummary('SGBLEConnectionState', 'disconnected', 'Ended connection with bluetooth')

        ];

        return enums;

    }

    public getProxStateEnums(): EnumSummary[]{
        const enums: EnumSummary[]  = [
            new EnumSummary('SGDeviceProximityState', 'deviceOutOfRange', 'Device is too far away from gaming machine'),
            new EnumSummary('SGDeviceProximityState', 'deviceInRange', 'Device is close enough to gaming machine')
        ];

        return enums;

    }

    public getPlayerProfileEnums(): EnumSummary[] {
        const enums: EnumSummary[] = [
            new EnumSummary('SGPlayerProfileState', 'unavailable', 'No player profile settings are available'),
            new EnumSummary('SGPlayerProfileState', 'pinSettingAvailable', 'pin setting requirements available'),
            new EnumSummary('SGPlayerProfileState', 'fundTransferSettingAvailable', 'funds transfer capability available'),
            new EnumSummary('SGPlayerProfileState', 'lastCashoutAvailable', 'Last cashout amount is available')

        ];

        return enums;

    }

    public getQRStateEnums(): EnumSummary[] {
        const enums: EnumSummary[]  = [
            new EnumSummary('SGQRConnectionState', 'idle', 'No connection established'),
            new EnumSummary('SGQRConnectionState', 'scanning', 'Attempting to read QR code'),
            new EnumSummary('SGQRConnectionState', 'scanned', 'Finihsed reading QR code')
        ];

        return enums;
    }

    public getSessionStateEnums(): EnumSummary[] {
        const enums: EnumSummary[]  = [
            new EnumSummary('SGPlayerSessionState', 'idle', 'No session in progress'),
            new EnumSummary('SGPlayerSessionState', 'creating', 'Creating player session'),
            new EnumSummary('SGPlayerSessionState', 'created', 'Player session succesfully created'),
            new EnumSummary('SGPlayerSessionState', 'ending', 'Ending player session'),
            new EnumSummary('SGPlayerSessionState', 'ended', 'Player session ended')
        ];
        return enums;
    }

    public getLogLevelEnums(): EnumSummary[] {
        const enums: EnumSummary[] = [
            new EnumSummary('SGLogLevel', 'debug', ''),
            new EnumSummary('SGLogLevel', 'info', ''),
            new EnumSummary('SGLogLevel', 'warn', ''),
            new EnumSummary('SGLogLevel', 'error', ''),
            new EnumSummary('SGLogLevel', 'fatal', '')
        ];

        return enums;
    }

    public getQRConnectStateEnums(): EnumSummary[] {
      const enums: EnumSummary[] = [
          new EnumSummary('SGQRConnectionState', 'idle', 'No activity in the scanner'),
          new EnumSummary('SGQRConnectionState', 'scanning', 'Camera is open and actively scanning'),
          new EnumSummary('SGQRConnectionState', 'scanned', 'A QR code was scanned and validated'),
          new EnumSummary('SGQRConnectionState', 'success', 'Session has been created in iView'),
          new EnumSummary('SGQRConnectionState', 'failure', 'Session creation failed'),
          new EnumSummary('SGQRConnectionState', 'error', 'Error scanning QR code'),
      ];

      return enums;
  }
}
